const env = {
  API_URL: process.env.REACT_APP_API_URL,
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  IS_PRODUCTION: process.env.REACT_APP_ENV === 'production',
  IS_DEVELOPMENT: process.env.REACT_APP_ENV === 'development',
  STRIPE_PRICE_ID_PREMIUM: process.env.REACT_APP_STRIPE_PRICE_ID_PREMIUM
};

export default env; 